'use strict';

import queryParamsController from './query-params';
import arrayUtilsController from './array-utils';
import timeUtilsController from './time-utils';

const MODULE_NAME = 'daupler.controllers';

var app = angular.module(MODULE_NAME, []);

app.controller('QueryParams', queryParamsController);
app.controller('ArrayUtils', arrayUtilsController);
app.controller('TimeUtils', timeUtilsController);

export default MODULE_NAME;
